module.exports = {
    methods: {
        show(zIndex) {
            if (document.getElementsByClassName('app-overlay').length > 0) {
                document.getElementsByClassName('app-overlay')[0].style.display = 'block';
                if (zIndex)
                    document.getElementsByClassName('app-overlay')[0].style.zIndex = zIndex;
            }
        },
        hide() {
            for (var i = 0; i < document.getElementsByClassName('app-overlay').length; i++) {
                document.getElementsByClassName('app-overlay')[i].style.display = '';
                document.getElementsByClassName('app-overlay')[i].style.zIndex = null;
            }
        },

        fullTopUrl: function () {
            let origin = new URL(document.referrer).href;
            let index = origin.toLowerCase().indexOf('/login');
            origin = origin.substring(0, index);
            return origin;
        },
        fullLocationUrl: function () {
            let subDirectories = new URL(location.href).pathname.split('/');
            let subDirectory = subDirectories.length >= 2 && subDirectories[1].trim() != '' ?
                `/${subDirectories[1]}` : '';
            let origin = new URL(location.href).origin + subDirectory;
            return origin;
        },
        subDirectory: function () {
            let subDirectories = new URL(location.href).pathname.split('/');
            return subDirectories.length >= 2 && subDirectories[1].trim() != '' ?
                `${subDirectories[1]}` : '';
        },
        fullTopUrlWithoutAppCode: function () {
            return window.location.origin;
        },
        getAppCode: function () {
            let subDirectories = new URL(document.referrer).pathname.split('/');
            let subDirectoriesFiltered = subDirectories.filter(function (item) {
                return item.includes("app-")
            });
            return subDirectoriesFiltered.length > 0 ? subDirectoriesFiltered[0] : "";
        },
        showFinishTaskButton: function (show) {
            function createLabelWaitingSignatures(label) {
                var div = document.createElement("div");
                div.id = "lblWaitingSignaturesHubSign";
                div.innerHTML = "<span class='badge badge-success text-truncate'>" + label + "</span>";
                return div;
            }

            const newLabelWaitingSignature = createLabelWaitingSignatures(this.$t('GENERAL.waitingSignatures'));

            const divButtons = document.querySelector('#buttons');
            const hubsignatureControlAttribute = divButtons.getAttribute('hubsignaturecontrol');
            //Se não encontrou o botão com o atributo de controle, significa que o Zeev está em versões anteriores. Vide explicação abaixo.
            if (!hubsignatureControlAttribute) {
                controlDivButtonsExibitionLegacy(show, newLabelWaitingSignature);
            }
            else {
                const event = new CustomEvent('control-finish-task-button', { detail: { show, newLabelWaitingSignature } });
                document.dispatchEvent(event);
            }

            /*O código contido nesta função foi movido para o Zeev na versão XXX, e é disparado através do evento control-finish-task-button.
            Alguns clientes utilizam o HubSignature com o Zeev em versões mais legadas, nas quais o código abaixo ainda não existe, e por isso está sendo mantido aqui por um tempo.
            Quando todos os clientes que usam o Zeev estiverem atualizados com versões XXX ou maiores, essa função controlDivButtonsExibitionLegacy
            e a sua respectiva chamada poderão ser removidos.*/
            function controlDivButtonsExibitionLegacy(show, newLabelWaitingSignature) {
                const elementsToKeep = [
                    document.getElementById('inpMobileFinalize'),//combo de outras opções em versões mais antigas do zeev
                    document.getElementById('inpOtherOptions'),//combo de outras opções em versões mais novas do zeev
                    document.querySelector('[onclick="cryo_returnAfterOpinion()"]')//botão de retornar após consulta a terceiro
                ];

                function shouldHideElement(element) {
                    return !elementsToKeep.includes(element.children[0]);
                }

                //const divButtons = document.querySelector('#buttons');
                const controllerElements = Array.from(divButtons.children);

                document.getElementById(newLabelWaitingSignature.id)?.remove();

                if (show)
                    controllerElements.forEach(x => x.style.visibility = 'visible')
                else {
                    controllerElements.filter(x => shouldHideElement(x)).forEach(x => x.style.visibility = 'hidden');
                    divButtons.appendChild(newLabelWaitingSignature);
                }
            }
        },
        setLanguage: function (language) {
            if (language === "en-US" || language === "pt-BR" || language === "es-ES")
                this.$i18n.locale = language;
            else
                this.$i18n.locale = "pt-BR";
        }
    }
}